export const EPISODE_DETAILS = 'EPISODE_DETAILS';
export const EPISODE_LIST = 'EPISODE_LIST';
export const EPISODE_PLAYBACKS = 'EPISODE_PLAYBACKS';
export const FORBIDDEN = 'FORBIDDEN';
export const NOT_FOUND = 'NOT_FOUND';
export const UNEXPECTED = 'UNEXPECTED';
